/**
 * Central registry of every SCORM course hosted under /public/courses/.
 * Key  = the course _id as stored in the backend.
 *
 * Each course has an optional `modules` array. When present, the /course/:id
 * route renders a module-listing landing page instead of launching a single
 * SCORM package.  Each module's `moduleId` is used as the courseId sent to
 * UPDATE_COURSE_PROGRESS so progress is tracked per module independently.
 */
export const COURSE_REGISTRY = {
  "69cff877b54cb88fb5c99cd7": {
    _id: "69cff877b54cb88fb5c99cd7",
    title: "CodePRep™ for Teams",
    enableModuleLocking: true,
    modules: [
      {
        slug: "module-1",
        moduleId: "69cff877b54cb88fb5c99cd7_module-1",
        title: "CodePRep Mindset",
        duration: "About 8 minutes",
        slides: 15,
        thumbnail: "/courses/code-prep/code-prep-teams/module-1/story_content/thumbnail.jpg",
        url: "/courses/code-prep/code-prep-teams/module-1/story.html",
      },
      {
        slug: "module-2",
        moduleId: "69cff877b54cb88fb5c99cd7_module-2",
        title: "Visual Acuity Scale",
        duration: "About 11 minutes",
        slides: 19,
        thumbnail: "/courses/code-prep/code-prep-teams/module-2/story_content/thumbnail.jpg",
        url: "/courses/code-prep/code-prep-teams/module-2/story.html",
      },
      {
        slug: "module-3",
        moduleId: "69cff877b54cb88fb5c99cd7_module-3",
        title: "Emergency Equipment",
        duration: "About 7 minutes",
        slides: 12,
        thumbnail: "/courses/code-prep/code-prep-teams/module-3/story_content/thumbnail.jpg",
        url: "/courses/code-prep/code-prep-teams/module-3/story.html",
      },
      {
        slug: "module-4",
        moduleId: "69cff877b54cb88fb5c99cd7_module-4",
        title: "Rescuer 1-2-3",
        duration: "About 6 minutes",
        slides: 12,
        thumbnail: "/courses/code-prep/code-prep-teams/module-4/story_content/thumbnail.jpg",
        url: "/courses/code-prep/code-prep-teams/module-4/story.html",
      },
      {
        slug: "module-5",
        moduleId: "69cff877b54cb88fb5c99cd7_module-5",
        title: "Putting It All Together",
        duration: "About 16 minutes",
        slides: 18,
        thumbnail: "/courses/code-prep/code-prep-teams/module-5/story_content/thumbnail.jpg",
        url: "/courses/code-prep/code-prep-teams/module-5/story.html",
      },
    ],
  },
};
